import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { agentsRegister, baseUrl, lang } from "../../../store/APILinks";

export const AgentRegister = createAsyncThunk(
  "agent/register",
  async (agentData, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${baseUrl}/${agentsRegister}`, agentData, {
        headers: {
          Accept: "application/json",
          "Accept-Language": lang,
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
export const AgentRegisterHandler = (builder) => {
  builder
    .addCase(AgentRegister.pending, (state) => {
      state.loading = true;
    })
    .addCase(AgentRegister.fulfilled, (state, action) => {
      state.loading = false;
      state.agentData = action.payload;
      state.error = null;
    })
    .addCase(AgentRegister.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
};
